// Countries State

export default {
  fullCountriesListEn: [],
  fullCountriesListAr: []
}
